export function parseEnvVarToStringArray(envVar: string | undefined): string[] {
	if (typeof envVar !== "string") {
		return [];
	}

	try {
		const parsedArray = JSON.parse(envVar) as Array<string | number | boolean | null>;
		if (!Array.isArray(parsedArray)) {
			return [];
		}
		return parsedArray.map((item) => {
			if (item === null) return "null";
			return String(item);
		});
	} catch (error) {
		console.error("Error parsing env var to string array:", error);
		return [];
	}
}

export function parseEnvVarToNumber(envVar: string | undefined): number | undefined {
	if (typeof envVar !== "string") return undefined;
	if (envVar === "") return undefined;
	const parsedNumber = Number(envVar);
	if (isNaN(parsedNumber)) return undefined;
	return parsedNumber;
}

export const UNEXPECTED_ERROR = "An unexpected error occurred. Please refresh the page and try again.";
